<template>
  <div class="lti-launch-page">
    <div class="lti-card">
      <b-spinner v-if="loading" variant="primary" class="mb-2" />
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  name: 'LtiLaunch',
  data() {
    return {
      loading: true,
      title: 'Connexion Blackboard…',
      message: 'Préparation de votre espace TUT’TOP.',
    }
  },
  mounted() {
    this.completeLaunch()
  },
  methods: {
    async completeLaunch() {
      const ticket = this.$route.query.ticket
      if (!ticket) {
        this.fail('Lien LTI invalide ou incomplet.')
        return
      }

      try {
        const { data } = await axios.post('/api/lti/session', { ticket })
        const { user, token } = data
        useJwt.setToken(token)
        useJwt.setRefreshToken(token)

        const userData = {
          id: user.id,
          avatar: user.photo,
          email: user.email,
          extras: { eCommerceCartItemsCount: 5 },
          fullName: user.fullName,
          role: user.role,
          username: user.username,
          onboardingCompleted: user.onboardingCompleted || false,
          ability: [{
            action: 'read',
            subject: user.role || 'student',
          }],
        }

        localStorage.setItem('userData', JSON.stringify(userData))
        if (this.$ability) this.$ability.update(userData.ability)

        const targetRoute = userData.role === 'student' && !userData.onboardingCompleted
          ? { name: 'student-onboarding' }
          : getHomeRouteForLoggedInUser(userData.role)

        this.$router.replace(targetRoute)
      } catch (e) {
        this.fail('La session Blackboard a expiré. Relancez TUT’TOP depuis Blackboard.')
      }
    },
    fail(message) {
      this.loading = false
      this.title = 'Connexion impossible'
      this.message = message
    },
  },
}
</script>

<style scoped>
.lti-launch-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f8fafc;
}

.lti-card {
  width: min(440px, calc(100vw - 2rem));
  padding: 2rem;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.12);
  text-align: center;
}

.lti-card h2 {
  margin: 0 0 0.75rem;
  color: #111827;
  font-weight: 800;
}

.lti-card p {
  margin: 0;
  color: #64748b;
}
</style>
